import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { get } from "lodash";

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AIRLINK_API,
    prepareHeaders: (headers, api) => {
      const state = api.getState();

      const authSecret = state.app.authSecret;

      if (authSecret) {
        headers.set("x-front-auth-secret", authSecret);
        headers.set("x-front-user-email", get(window.Front, "user.email", ""));
      }

      return headers;
    }
  }),
  endpoints: () => ({})
});
